import React from 'react';
import styled, { keyframes } from 'styled-components';
import FcLoader from '../assets/images/fc-loader.png';

const Container = styled.div`
    z-index: 100000;
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translateY(-50%);
    transform: translateX(50%);
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const LoadingIcon = styled.div`
    width: 80px;
    height: 80px;
    transform: translateY(-50%);
    background-image: url(${FcLoader});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    animation: ${rotate} 1s linear infinite;
`;

function LoadingIndicator(){

    return (
        <Container>
            <LoadingIcon />
        </Container>
    )
}

export default LoadingIndicator;